import { render, staticRenderFns } from "./CreateZaitonPlusContract.vue?vue&type=template&id=36b5e664&"
import script from "./CreateZaitonPlusContract.vue?vue&type=script&lang=js&"
export * from "./CreateZaitonPlusContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports